// Utility to keep Open Graph tags in sync with the current route.
// The classic Vite stack ships a single static <head> in index.html, so we
// patch og:title / og:description / og:url at runtime per page.

export const updateOpenGraph = (opts: {
  title?: string;
  description?: string;
  url?: string;
  type?: string;
}) => {
  const setMeta = (selector: string, attr: "name" | "property", key: string, content: string) => {
    let el = document.querySelector(selector) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (opts.title) {
    setMeta('meta[property="og:title"]', "property", "og:title", opts.title);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", opts.title);
  }
  if (opts.description) {
    setMeta('meta[property="og:description"]', "property", "og:description", opts.description);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", opts.description);
  }
  if (opts.url) {
    setMeta('meta[property="og:url"]', "property", "og:url", opts.url);
  }
  if (opts.type) {
    setMeta('meta[property="og:type"]', "property", "og:type", opts.type);
  }
};
